import computeCssObjectsFromClasses from '../utils/compute-css-objects-from-classes';

function generateCssObjectsForStyleGroups() {
  if (!Object.keys(window.$styleGroupsToGenerateCssObjects).length) {
    return;
  }

  for(let styleGroupName in window.$styleGroupsToGenerateCssObjects) {
    const styleGroupClasses = window.$styleGroupsToGenerateCssObjects[styleGroupName].trim();
    const styles = computeCssObjectsFromClasses(styleGroupClasses.split(' '));

    window.$theme.$styleGroupsCssObjectMap[styleGroupName] = styles;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  generateCssObjectsForStyleGroups();
});

document.addEventListener('jb.section.rendered', () => {
  generateCssObjectsForStyleGroups();
});

document.addEventListener('section.initiated', () => {
  generateCssObjectsForStyleGroups();
});
